import { makeVar } from '@apollo/client'
import { Metadata } from '@deltek/specification-client/core/Models/metadata'
import { EditorState, SelectionState } from 'draft-js'
import { Justification } from 'models/projectStyle'
import { FontSettings } from './styleGuides'

export interface ProjectHeaderAndFooter {
    isActive: boolean
    isDefault: boolean
    name: string
    headerAndFooters: HeaderAndFooterStyle
    headerMergeFieldContent: MergeFieldContent[]
    footerMergeFieldContent: MergeFieldContent[]
    footerCopyright: MergeFieldContent | null
    projectId: string
    siteId: string
    id: string
    firmId: string
    metadata: Partial<Metadata>
    isEnablePreview: boolean
}
export interface HeaderAndFooterStyle {
    fontSettings: FontSettings
    justification: Justification
    headerFromTop: number
    footerFromBottom: number
    headerColumn: number
    footerColumn: number
    mergeFields: HeaderAndFooterMergeField[]
}

export interface HeaderAndFooterMergeField {
    fieldName: string
    actualValue: string
}

export interface MergeFieldContent {
    mergeFieldFormat: string
    columnNumber: number
    justification: Justification
}

export const defaultActiveHeaderFooter: ProjectHeaderAndFooter = {
    isActive: true,
    isDefault: true,
    name: '',
    headerAndFooters: {
        fontSettings: {
            fontColor: '#000000',
            fontFamily: 'Arial',
            fontStyles: [],
            fontSize: 11,
        },
        justification: 'LEFT',
        headerFromTop: 0.4,
        footerFromBottom: 0.2,
        headerColumn: 3,
        footerColumn: 2,
        mergeFields: [],
    },
    headerMergeFieldContent: [
        { mergeFieldFormat: '', columnNumber: 1, justification: 'LEFT' },
        { mergeFieldFormat: '', columnNumber: 2, justification: 'CENTER' },
        { mergeFieldFormat: '', columnNumber: 3, justification: 'RIGHT' },
    ],
    footerMergeFieldContent: [
        { mergeFieldFormat: '', columnNumber: 1, justification: 'LEFT' },
        { mergeFieldFormat: '', columnNumber: 2, justification: 'RIGHT' },
    ],
    footerCopyright: { mergeFieldFormat: '', columnNumber: 1, justification: 'LEFT' },
    projectId: '',
    siteId: '',
    id: '',
    firmId: '',
    metadata: {},
    isEnablePreview: false,
}

const defaultHeaderFooterTemplateList: ProjectHeaderAndFooter[] = []

const defaultEditorState = EditorState.createEmpty()
const defaultSelection: SelectionState = defaultEditorState.getSelection()

export const activeSelection = makeVar<SelectionState>(defaultSelection)

export const setActiveSelection = (value: SelectionState) => {
    activeSelection(value)
}

export const activeHeaderFooter = makeVar<ProjectHeaderAndFooter>(
    defaultActiveHeaderFooter
)

export const headerFooterTemplateList = makeVar<ProjectHeaderAndFooter[]>(
    defaultHeaderFooterTemplateList
)

export const isHeaderActive = makeVar<boolean>(true)

export const setActiveHeaderFooter = (value: ProjectHeaderAndFooter) => {
    activeHeaderFooter(value)
}

export const setHeaderFooterList = (value: ProjectHeaderAndFooter[]) => {
    headerFooterTemplateList(value)
}

export const setHeadersAndFooters = (value: HeaderAndFooterStyle) => {
    const headerAndFooter = activeHeaderFooter()

    headerAndFooter &&
        activeHeaderFooter({
            ...headerAndFooter,
            headerAndFooters: value,
        })
}

export const setHeaderMergeFields = (value: MergeFieldContent[]) => {
    const headerAndFooter = activeHeaderFooter()

    headerAndFooter &&
        activeHeaderFooter({
            ...headerAndFooter,
            headerMergeFieldContent: [...value],
        })
}

export const setFooterMergeFields = (value: MergeFieldContent[]) => {
    const headerAndFooter = activeHeaderFooter()

    headerAndFooter &&
        activeHeaderFooter({
            ...headerAndFooter,
            footerMergeFieldContent: [...value],
        })
}

export const setFooterCopyright = (value: MergeFieldContent | null) => {
    const headerAndFooter = activeHeaderFooter()

    headerAndFooter &&
        activeHeaderFooter({
            ...headerAndFooter,
            footerCopyright: value,
        })
}

export const setIsHeaderActive = (value: boolean) => {
    isHeaderActive(value)
}

export const setEnablePreview = (value: boolean) => {
    const headerAndFooter = activeHeaderFooter()

    headerAndFooter &&
        activeHeaderFooter({
            ...headerAndFooter,
            isEnablePreview: value,
        })
}
